import { render, staticRenderFns } from "./feed.vue?vue&type=template&id=4df0b8d0"
import script from "./feed.vue?vue&type=script&lang=ts"
export * from "./feed.vue?vue&type=script&lang=ts"
import style0 from "./feed.vue?vue&type=style&index=0&id=4df0b8d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports